//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';

export const generateRatingWidth = (averageRating = 0) => (
  parseFloat(Math.round(averageRating * 20).toString())
);

export default {
  name: 'TacoRating',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    onlyTacos: {
      type: Boolean,
    },
    isDealCard: {
      type: Boolean,
    },
  },
  data() {
    return {
      reviewCount: get(this, ['deal', 'deal_review', 'review_count'], 0),
    };
  },
  computed: {
    getPercentRating() {
      // each taco is roughly 15% of the width with 5px apart on browse, 8px apart on tools/etc
      const widthPercent = generateRatingWidth(this.deal.deal_review.average_rating) * 0.75;
      const tacoSpaces = (this.deal.deal_review.average_rating >= 1)
        ? Math.floor(this.deal.deal_review.average_rating)
        : 0;

      let propMultiplier = 1;

      if (this.onlyTacos) {
        propMultiplier = 1.3;
      } else {
        propMultiplier = 1.23;
      }

      const pixelMultiplier = this.isDealCard ? 6.5 : 6;

      return `calc(${widthPercent}% + ${(pixelMultiplier * tacoSpaces * propMultiplier)}px)`;
    },
    reviewLinkRel() {
      return this.isDealCard ? null : 'nofollow';
    },
    reviewLinkUrl() {
      if (this.isDealCard) {
        return `${this.deal.get_absolute_url}#reviews`;
      }
      return null;
    },
    reviewCountLabel() {
      if (this.reviewCount === 1) {
        return 'Review';
      }

      return 'Reviews';
    },
  },
  methods: {
    reviewLinkOnClick() {
      // the deal card links to a URL, so no need for scroll handling on this side.
      if (this.isDealCard) {
        return;
      }

      const state = {};
      window.history.pushState(state, '', '#reviews');
      dispatchEvent(new PopStateEvent('popstate', { state }));
    },
  },
};
